import Vue from 'vue';

Vue.mixin({
  methods: {
    hasAccess(access) {
      const {user} = this.$store.state;
      return user && user.roles && user.roles.indexOf(access) > -1;
    },
    entitlementCheck(entitlement) {
      return (
        this.$store.state &&
        this.$store.state.customer &&
        this.$store.state.customer.entitlements &&
        this.$store.state.customer.entitlements.indexOf(entitlement) > -1
      );
    }
  }
});
